module.exports = "<h4>Promociones</h4>\n"